module.exports = __webpack_public_path__ + "img/31_1.2e42d543.jpg";